import { Code, Smartphone, ShieldCheck, Cloud, BarChart, Cpu, Target, Layers, Rocket } from 'lucide-react';
import web1 from "../../assets/web1.jpg";
import App1 from "../../assets/App1.jpg";
import secu1 from "../../assets/secu1.jpg";
import Aud1 from "../../assets/Aud1.jpg";
import dig1 from "../../assets/dig1.png";
import mat1 from "../../assets/mat1.jpg";

// ================================================
// COULEURS MYRIADE
// ================================================
export const myriadeColors = {
    red: '#db1f26',
    green: '#32b34a',
    yellow: '#fecd08',
    blue: '#3a55a5',
    gradientBlue: ['#24295c', '#287bb3'],
    gradientBrown: ['#2c1dcaff', '#051da0ff']
};

// ================================================
// DONNÉES DES SERVICES
// ================================================
export const services = [
    {
        title: "Développement Web Sur-Mesure",
        tagline: "Solutions digitales performantes",
        description: "Nous concevons des applications web scalables et sécurisées avec les dernières technologies. Notre approche agile garantit des solutions alignées avec vos objectifs métiers.",
        image: web1,
        icon: Code,
        color: "myriade-gradient-blue",
        colorValue: myriadeColors.blue,
        particles: 12,
        shape: "hexagon"
    },
    {
        title: "Applications Mobiles",
        tagline: "Expérience utilisateur premium",
        description: "Développement d'applications natives et cross-platform offrant une expérience utilisateur exceptionnelle sur iOS et Android.",
        image: App1,
        icon: Smartphone,
        color: "myriade-green",
        colorValue: myriadeColors.green,
        particles: 8,
        shape: "circle"
    },
    {
        title: "Sécurité & Pentests",
        tagline: "Protection optimale",
        description: "Audits de sécurité complets et tests d'intrusion pour identifier et corriger les vulnérabilités avant qu'elles ne soient exploitées.",
        image: secu1,
        icon: ShieldCheck,
        color: "myriade-red",
        colorValue: myriadeColors.red,
        particles: 16,
        shape: "triangle"
    },
    {
        title: "Audits Infrastructure",
        tagline: "Infrastructure sécurisée",
        description: "Évaluation complète de vos infrastructures cloud et on-premise avec recommandations personnalisées pour optimiser performance et sécurité.",
        image: Aud1,
        icon: Cloud,
        color: "myriade-brown",
        colorValue: myriadeColors.gradientBrown[1],
        particles: 10,
        shape: "square"
    },
    {
        title: "Conseil Digital",
        tagline: "Stratégie gagnante",
        description: "Accompagnement stratégique pour votre transformation digitale avec une feuille de route claire et des KPIs mesurables.",
        image: dig1,
        icon: BarChart,
        color: "myriade-yellow",
        colorValue: myriadeColors.yellow,
        particles: 14,
        shape: "hexagon"
    },
    {
        title: "Infrastructure IT",
        tagline: "Matériel & Maintenance",
        description: "Fourniture de matériel haute performance et services de maintenance proactive avec SLA garantis pour votre continuité opérationnelle.",
        image: mat1,
        icon: Cpu,
        color: "myriade-gradient-blue",
        colorValue: myriadeColors.gradientBlue[1],
        particles: 12,
        shape: "circle"
    }
];

// ================================================
// DONNÉES DES ÉTAPES DE PROCESSUS
// ================================================
export const processSteps = [
    {
        title: "Exploration & Analyse",
        description: "Audit complet de vos besoins et analyse des opportunités technologiques.",
        icon: Target,
        color: myriadeColors.blue,
        duration: "1-2 semaines",
        features: ["Analyse SWOT", "Benchmark", "Étude de faisabilité"]
    },
    {
        title: "Conception Stratégique",
        description: "Définition de l'architecture et design de l'expérience utilisateur.",
        icon: Layers,
        color: myriadeColors.gradientBlue[0],
        duration: "2-3 semaines",
        features: ["Wireframes", "Prototypes", "Architecture technique"]
    },
    {
        title: "Développement Agile",
        description: "Création itérative avec tests continus et revues de code.",
        icon: Code,
        color: myriadeColors.green,
        duration: "4-8 semaines",
        features: ["Sprints Agile", "Code Review", "Tests automatisés"]
    },
    {
        title: "Livraison & Support",
        description: "Déploiement, formation et maintenance proactive.",
        icon: Rocket,
        color: myriadeColors.yellow,
        duration: "Continuel",
        features: ["Déploiement", "Formation", "Support 24/7"]
    }
];

// ================================================
// HELPER FUNCTIONS
// ================================================
export const getServiceGradient = (service) => {
    switch (service.color) {
        case 'myriade-gradient-blue':
            return `linear-gradient(135deg, ${myriadeColors.gradientBlue[0]}, ${myriadeColors.gradientBlue[1]})`;
        case 'myriade-green':
            return `linear-gradient(135deg, ${myriadeColors.green}, #11114aff)`;
        case 'myriade-red':
            return `linear-gradient(135deg, ${myriadeColors.red}, #ce4c4cff)`;
        case 'myriade-brown':
            return `linear-gradient(135deg, ${myriadeColors.gradientBrown[0]}, ${myriadeColors.gradientBrown[1]})`;
        case 'myriade-yellow':
            return `linear-gradient(135deg, ${myriadeColors.yellow}, #ffdd40)`;
        default:
            return `linear-gradient(135deg, ${myriadeColors.blue}, #cdd8f5ff)`;
    }
};

export const getServiceLightColor = (service) => {
    switch (service.color) {
        case 'myriade-gradient-blue':
            return '#24295c20';
        case 'myriade-green':
            return '#32b34a20';
        case 'myriade-red':
            return '#db1f2620';
        case 'myriade-brown':
            return '#5d191a20';
        case 'myriade-yellow':
            return '#fecd0820';
        default:
            return '#3a55a520';
    }
};
